import React, {FC, useState, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {
  InputText,
  InputNumber,
  InputDate,
  InputTextArea,
} from '../../../../../../components/UI/Input'
import {Select} from '../../../../../../components/UI/Select'
import {
  getSite,
  getClient,
  getCompany,
  getCamp,
  getMasterService,
  getUser,
} from '../../../../services'
import {
  CampModel,
  SiteModel,
  ClientModel,
  CompanyModel,
  ModuleModel,
  UserModel,
} from '../../../../model'
import {useCentral} from '../../../../../../hooks/useCentral'
import {SelectModel} from '../../../../../lavanderia/model'
import moment from 'moment'
import {paginationGuestsService} from '../../../../../hoteleria/features/guests/services'
import {getClaimById, getClaims} from '../../../../services/claim.service'
import {formatDate} from '../../../../../../util/dates'
import {SnackbarProvider} from 'notistack'
import {useAuth} from '../../../../../../hooks/useAuth'
import {getGuestLastBookingByIdService} from '../../../../../hoteleria/services/guest.service'
import {SelectAsync} from '../../../../../../components/UI/SelectV2'

const Index: FC = () => {
  const {
    setError,
    register,
    formState: {errors},
    control,
    setValue,
    watch,
  } = useFormContext()
  const {applications} = useAuth()
  const mappedSites = applications.map((item: any) => ({
    value: item.aplicacionId,
    label: item.description,
  }))

  const {currentTabItem} = useCentral()
  const [site, setSite] = useState<SiteModel[] | any>([])
  const [client, setClient] = useState<ClientModel[] | any>([])
  const [company, setCompany] = useState<CompanyModel[] | any>([])
  const [camp, setCamp] = useState<SelectModel[]>([])
  const [requerimentTypes, setRequerimentTypes] = useState<SelectModel[]>([])
  const [claimTypes, setClaimTypes] = useState<SelectModel[]>([])
  const [isGuest, setIsGuest] = useState<boolean>(false)
  const [isClaimant, setIsClaimant] = useState<boolean>(false)
  const [users, setUsers] = useState<any[]>([])
  const [guests, setGuests] = useState<any[]>([])
  const [claim, setClaim] = useState<ModuleModel[]>([])

  const getClaimList = async (val: any) => {
    const response = await getClaims({
      pageNumber: 1,
      size: 100,
      SiteId: val,
    })
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.Id, label: 'N° ' + item.NroRequerimiento}))
    setClaim(mappedSites)
  }
  const getSiteList = async (valCli: any, val: any) => {
    let obj: SiteModel = {
      isCombo: true,
      clienteId: valCli,
      id: val,
    }
    const response = await getSite(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setSite(mappedSites)
  }
  const getCompanyList = async () => {
    let obj: CompanyModel = {
      isCombo: true,
    }
    const response = await getCompany(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombreEmpresa}))
    setCompany(mappedSites)
  }
  const getClientList = async (valcom: any, val: any) => {
    let obj: ClientModel = {
      isCombo: true,
      companiaId: valcom,
      id: val,
    }
    const response = await getClient(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setClient(mappedSites)
  }
  const getCampList = async (valSite: any, val: any) => {
    let obj: CampModel = {
      isCombo: true,
      siteId: valSite,
      id: val,
    }
    const response = await getCamp(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setCamp(mappedSites)
  }

  const getUsers = async (filters: UserModel, page: number) => {
    try {
      const response = await getUser(filters, 1)
      const data = response.data.data
      const mappedUsers = data?.map((user) => ({
        value: user.id,
        label: `${user.nombres || ''} ${user.apellidos || ''} ${user.numeroDocumento || ''}`,
        ...user,
      }))
      setUsers(mappedUsers)
    } catch (error) {
      return []
    }
  }

  const getGuests = async (campId: string) => {
    try {
      const {data: response} = await paginationGuestsService({
        pageNumber: 1,
        size: 2000,
        isCombo: true,
        // CampamentoId: campId,
      })
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno}`,
          ...guest,
        }))
        setGuests(mappedGuests)
      }
    } catch (error) {
      setGuests([])
    }
  }

  const getClaimId = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await getClaimById(idToEdit as any)
        const {
          Id,
          CompaniaId,
          ClienteId,
          SiteId,
          CampamentoId,
          TipoRequerimientoId,
          AplicacionId,
          FechaRequerimiento,
          ReclamanteId,
          HuespedId,
          ColaboradorId,
          ReservaCamaId,
          Reclamo,
          CodigoReclamoId,
          Huesped_nombre,
          Huesped_nroDoc,
          Huesped_tipo,
          Huesped_modulo,
          Huesped_habitacion,
          Huesped_cama,
          Huesped_empresa,
          Huesped_telefono,
          Huesped_email,
          Colaborador_nombre,
          Colaborador_cargo,
          Colaborador_empresa,
          Colaborador_telefono,
          Colaborador_email,
          Colaborador_nrodocumento,
          Campoadicionaltxt1,
          Campoadicionaltxt2,
          Campoadicionaltxt3,
          Campoadicionaltxt4,
          Campoadicionaltxt5,
          Campoadicionalnum1,
          Campoadicionalnum2,
          Campoadicionalnum3,
          CampoadicionalFec1,
          CampoadicionalFec2,
        } = data
        setValue('Id', Id)
        setValue('CompaniaId', CompaniaId)
        setValue('ClienteId', ClienteId)
        setValue('SiteId', SiteId)
        setValue('CampamentoId', CampamentoId)
        setValue('TipoRequerimientoId', TipoRequerimientoId)
        setValue('AplicacionId', AplicacionId)
        setValue('ReclamanteId', ReclamanteId)
        setValue('ColaboradorId', ColaboradorId || '')
        setValue('HuespedId', HuespedId || '')
        setValue('ReservaCamaId', ReservaCamaId)
        setValue('Huesped_descripcion', `${Huesped_nombre} ${Huesped_nroDoc}`)
        setValue('Huesped_Tipo', Huesped_tipo)
        setValue('Huesped_Modulo', Huesped_modulo)
        setValue('Huesped_Habitacion', Huesped_habitacion)
        setValue('Huesped_Cama', Huesped_cama)
        setValue('Huesped_Empresa', Huesped_empresa)
        setValue('Huesped_Telefono', Huesped_telefono)
        setValue('Huesped_Email', Huesped_email)
        setValue('Colaborador_Cargo', Colaborador_cargo)
        setValue('CodigoReclamoId', CodigoReclamoId)
        setValue('Colaborador_Empresa', Colaborador_empresa)
        setValue('Colaborador_Telefono', Colaborador_telefono)
        setValue('Colaborador_Email', Colaborador_email)
        setValue('Colaborador_descripcion', `${Colaborador_nombre} ${Colaborador_nrodocumento}`)
        setValue('Campoadicionaltxt1', Campoadicionaltxt1)
        setValue('Campoadicionaltxt2', Campoadicionaltxt2)
        setValue('Campoadicionaltxt3', Campoadicionaltxt3)
        setValue('Campoadicionaltxt4', Campoadicionaltxt4)
        setValue('Campoadicionaltxt5', Campoadicionaltxt5)
        setValue('FechaRequerimiento', formatDate(FechaRequerimiento))
        let num1 = Campoadicionalnum1 ? (Campoadicionalnum1 === 0 ? '' : Campoadicionalnum1) : ''
        let num2 = Campoadicionalnum2 ? (Campoadicionalnum2 === 0 ? '' : Campoadicionalnum2) : ''
        let num3 = Campoadicionalnum3 ? (Campoadicionalnum3 === 0 ? '' : Campoadicionalnum3) : ''
        if (ReclamanteId === '+BPMQ4keWgI=') {
          setIsGuest(true)
          setIsClaimant(false)
        } else {
          setIsGuest(false)
          setIsClaimant(true)
        }
        setValue('Campoadicionalnum1', num1)
        setValue('Campoadicionalnum2', num2)
        setValue('Campoadicionalnum3', num3)
        setValue('CampoadicionalFec1', CampoadicionalFec1)
        setValue('CampoadicionalFec2', CampoadicionalFec2)
        setValue('Reclamo', Reclamo)
        getClientList(CompaniaId as any, '')
        getSiteList(ClienteId as any, '')
        getCampList(SiteId as any, '')
        getClaimList(SiteId as any)
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getClaimId()
    }
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    getCompanyList()
    getRequerimentTypes()
    getClaimTypes()
    getUsers({isCombo: true}, 1)
  }, [])

  const getRequerimentTypes = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoRequerimiento',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setRequerimentTypes(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de requerimientos:', error)
    }
  }

  const getClaimTypes = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'Reclamante',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setClaimTypes(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de reclamante:', error)
    }
  }

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      //   getCampByIdValues()
    }
  }, [currentTabItem.idToEdit])
  let isDisabled = currentTabItem.idToEdit ? true : false
  const handleGetClientList = async (val: any) => {
    let value = val ? val.value : ''
    getClientList(value, '')
    setValue('CompaniaId', value)
    setError('CompaniaId', {})
  }
  const handleGetSiteList = async (val: any) => {
    let value = val ? val.value : ''
    getSiteList(value, '')
    setValue('ClienteId', value)
    setError('ClienteId', {})
  }

  const handleGetCampList = async (val: any) => {
    let value = val ? val.value : ''
    getCampList(value, '')
    setValue('SiteId', value)
    setError('SiteId', {})
    getClaimList(value)
  }

  const handleGetClaimant = async (val: any) => {
    let value = val ? val.value : ''
    if (value === '+BPMQ4keWgI=') {
      //ID DE HUESPED
      setValue('ReclamanteId', value)
      setError('ReclamanteId', {})
      setValue('Colaborador_Cargo', '')
      setValue('Colaborador_Empresa', '')
      setValue('Colaborador_Telefono', '')
      setValue('Colaborador_Email', '')
      setIsGuest(true)
      setIsClaimant(false)
    } else {
      setValue('ReclamanteId', value)
      setError('ReclamanteId', {})
      setValue('Huesped_Tipo', '')
      setValue('Huesped_Modulo', '')
      setValue('Huesped_Cama', '')
      setValue('Huesped_Empresa', '')
      setValue('Huesped_Telefono', '')
      setValue('Huesped_Email', '')
      setIsGuest(false)
      setIsClaimant(true)
    }
  }

  const handleSetUserInfo = async (val: any) => {
    let value = val ? val.value : ''
    setValue('ColaboradorId', value)
    setValue('Colaborador_descripcion', val.label)
    setError('ColaboradorId', {})
    setValue('Colaborador_Cargo', val.cargo)
    setValue('Colaborador_Empresa', val.empresa)
    setValue('Colaborador_Telefono', val.telefono)
    setValue('Colaborador_Email', val.email)
  }

  const handleSetGuestInfo = async (val: any) => {
    let value = val ? val.value : ''
    setValue('HuespedId', value)
    setValue('Huesped_descripcion', val.label)
    setValue('Huesped_Empresa', val.Empresa_descripcion)
    setValue('Huesped_Telefono', val.Telefono)
    setValue('Huesped_Email', val.Email)
    setValue('Huesped_Tipo', val.TipoHuesped_descripcion)
    setValue('Huesped_Modulo', '')
    setValue('Huesped_Habitacion', '')
    setValue('Huesped_Cama', '')
    setValue('ReservaCamaId', '')
    setError('HuespedId', {})

    const {data} = await getGuestLastBookingByIdService(value)
    if (!data.error) {
      const guest = data.data
      setError('HuespedId', {})
      setValue('Huesped_Modulo', guest.UltimaReserva_ModuloId)
      setValue('Huesped_Habitacion', guest.UltimaReserva_HabitacionId)
      setValue('Huesped_Cama', guest.UltimaReserva_CamaId)
      setValue('ReservaCamaId', guest.UltimaReserva_ReservaCamaId)
    }
  }

  const loadOptions = async (inputValue: string) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const {data: response} = await paginationGuestsService({
        pageNumber: 1,
        size: 500,
        CampamentoId: watch('CampamentoId') || null,
        isCombo: true,
        BuscaTexto: inputValue,
      })
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno} ${guest.NumeroDocumento}`,
          ...guest,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }

  const loadOptionsColab = async (inputValue: string) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const response = await getUser(
        {isCombo: true, campamentoId: watch('CampamentoId') || null, BuscaTexto: inputValue},
        1,
      )
      if (!response.data.error) {
        const data = response.data.data
        const mappedUsers = data?.map((user) => ({
          value: user.id,
          label: `${user.nombres || ''} ${user.apellidos || ''} ${user.numeroDocumento || ''}`,
          ...user,
        }))
        return mappedUsers
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }

  return (
    <div className='sdx_form card p-4'>
      <h4>Datos de Requerimiento</h4>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Compañía</label>
          <Select
            control={control}
            name='CompaniaId'
            data={company}
            errors={errors}
            disabled={isDisabled}
            onChangeValue={handleGetClientList}
          />
        </div>

        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Cliente</label>
          <Select
            control={control}
            name='ClienteId'
            data={client}
            errors={errors}
            disabled={isDisabled}
            onChangeValue={handleGetSiteList}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Site</label>
          <Select
            control={control}
            name='SiteId'
            data={site}
            errors={errors}
            disabled={isDisabled}
            onChangeValue={handleGetCampList}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Campamento:</label>
          <Select
            control={control}
            name='CampamentoId'
            data={camp}
            errors={errors}
            disabled={isDisabled}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Tipo de Requerimiento:</label>
          <Select
            control={control}
            name='TipoRequerimientoId'
            data={requerimentTypes}
            errors={errors}
            // disabled={isDisabled}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Módulo:</label>
          <Select
            control={control}
            name='AplicacionId'
            data={mappedSites}
            errors={errors}
            // disabled={isDisabled}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Fecha de Reclamo:</label>
          <InputDate
            name='FechaRequerimiento'
            register={register}
            errors={errors}
            minValue='1900-01-01'
            defaultValue={moment().format('YYYY-MM-DD')}
            // disabled={isDisabled}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label>Reclamos precedente:</label>
          <Select
            control={control}
            name='CodigoReclamoId'
            data={claim}
            errors={errors}
            disabled={isDisabled}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label className='required'>Reclamante:</label>
          <Select
            control={control}
            name='ReclamanteId'
            data={claimTypes}
            errors={errors}
            // disabled={isDisabled}
            onChangeValue={handleGetClaimant}
          />
        </div>

        {/* Si es Huesped */}
        {isGuest ? (
          <>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className='required'>Datos Reclamante:</label>
              <SelectAsync
                loadOptions={loadOptions as any}
                name='HuespedId'
                disabled={!watch('CampamentoId') || isDisabled}
                value={
                  watch('HuespedId')
                    ? {
                        value: watch('HuespedId') || '',
                        label: watch('Huesped_descripcion') || '',
                      }
                    : null
                }
                onChangeValue={handleSetGuestInfo}
                textPlaceholder='Buscar Huésped...'
              />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Status de Huésped:</label>
              <InputText register={register} name='Huesped_Tipo' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Módulo de Habitación:</label>
              <InputText register={register} name='Huesped_Modulo' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Habitación:</label>
              <InputText register={register} name='Huesped_Habitacion' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Cama:</label>
              <InputText register={register} name='Huesped_Cama' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Empresa:</label>
              <InputText register={register} name='Huesped_Empresa' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Teléfono:</label>
              <InputText register={register} name='Huesped_Telefono' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Email:</label>
              <InputText register={register} name='Huesped_Email' errors={errors} disabled />
            </div>
          </>
        ) : (
          <></>
        )}

        {/* Si es colaborador */}
        {isClaimant ? (
          <>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className='required'>Datos Reclamante:</label>
              <SelectAsync
                loadOptions={loadOptionsColab as any}
                name='ColaboradorId'
                disabled={!watch('CampamentoId') || isDisabled}
                value={
                  watch('ColaboradorId')
                    ? {
                        value: watch('ColaboradorId') || '',
                        label: watch('Colaborador_descripcion') || '',
                      }
                    : null
                }
                onChangeValue={handleSetUserInfo}
                textPlaceholder='Buscar Colaborador...'
              />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Cargo del colaborador:</label>
              <InputText register={register} name='Colaborador_Cargo' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Empresa del colaborador:</label>
              <InputText register={register} name='Colaborador_Empresa' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Teléfono del colaborador:</label>
              <InputText register={register} name='Colaborador_Telefono' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Email del colaborador:</label>
              <InputText register={register} name='Colaborador_Email' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Datos del Huésped:</label>
              <Select
                control={control}
                name='HuespedId'
                data={guests}
                errors={errors}
                disabled={isDisabled}
                onChangeValue={handleSetGuestInfo}
              />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Status de Huésped:</label>
              <InputText register={register} name='Huesped_Tipo' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Módulo de Habitación:</label>
              <InputText register={register} name='Huesped_Modulo' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Habitación:</label>
              <InputText register={register} name='Huesped_Habitacion' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Cama:</label>
              <InputText register={register} name='Huesped_Cama' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Empresa:</label>
              <InputText register={register} name='Huesped_Empresa' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Teléfono:</label>
              <InputText register={register} name='Huesped_Telefono' errors={errors} disabled />
            </div>
            <div className='col-sm-12 col-md-4 col-xl-3'>
              <label className=''>Email:</label>
              <InputText register={register} name='Huesped_Email' errors={errors} disabled />
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
      <div className='row'>
        <div className='col-sm-12 col-lg-6'>
          <label className='required'>Reclamo:</label>
          <InputTextArea
            name='Reclamo'
            textPlaceholder='Escribe el reclamo'
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <hr className='divider' />
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label>Texto adicional 1:</label>
          <InputText
            name='campoadicionaltxt1'
            textPlaceholder='Escribe el texto adicional'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label>Texto adicional 2:</label>
          <InputText
            name='campoadicionaltxt2'
            textPlaceholder='Escribe el texto adicional'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label>Texto adicional 3:</label>
          <InputText
            name='campoadicionaltxt3'
            textPlaceholder='Escribe el texto adicional'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label>Texto adicional 4:</label>
          <InputText
            name='campoadicionaltxt4'
            textPlaceholder='Escribe el texto adicional'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label>Texto adicional 5:</label>
          <InputText
            name='campoadicionaltxt5'
            textPlaceholder='Escribe el texto adicional'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label>Número adicional 1:</label>
          <InputNumber
            name='campoadicionalnum1'
            textPlaceholder='Escribe el número'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label>Número adicional 2:</label>
          <InputNumber
            name='campoadicionalnum2'
            textPlaceholder='Escribe el número'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label>Número adicional 3:</label>
          <InputNumber
            name='campoadicionalnum3'
            textPlaceholder='Escribe el número'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label>Fecha adicional 1:</label>
          <InputDate name='campoadicionalFec1' register={register} errors={errors} />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <label>Fecha adicional 2:</label>
          <InputDate name='campoadicionalFec2' register={register} errors={errors} />
        </div>
      </div>
      <SnackbarProvider />
    </div>
  )
}

export default Index
